export default {
  SET_SALES_MANUAL_DATA(state, data) {
    state.sales_manuals = data;
  },
};
